import axios from 'axios';
import { BaseApiService } from '@/services/backend/base';
import { Certificate } from 'crypto-pro';
import store from '@/store';
import { prepareCertificateOwnerInfo } from '@/helpers';

export class PersonalOrganizationProfileAPIService extends BaseApiService {
    constructor() {
        super('personal/organization_profile');
    }

    async updateInformation(data: any) {
        try {
            await axios.put(this.getUrl(), data);
            await store.dispatch('showSuccessToast', 'Данные организации успешно обновлены');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }
}
